import About from "./About";
import Achievements from "./Achievements";
import Certifications from "./Certifications";
import Contact from "./Contact";
import Education from "./Education";
import Experience from "./Experience";
import Home from "./Home";
import Services from "./Services";
import Skills from "./Skills";
import Work from "./Work";

/** Maps navigation section ids to React section components. */
export const sectionComponents = {
  home: Home,
  about: About,
  skills: Skills,
  services: Services,
  education: Education,
  experience: Experience,
  work: Work,
  certifications: Certifications,
  achievements: Achievements,
  contact: Contact,
};
